export const PaddingTopClasses = {
  PADDING_TOP_NONE: ['wf-pt-0'],
  PADDING_TOP_XXXS: ['wf-pt-1'],
  PADDING_TOP_XXS: ['wf-pt-2'],
  PADDING_TOP_XS: ['wf-pt-4'],
  PADDING_TOP_XSS: ['wf-pt-6'],
  PADDING_TOP_SSM: ['wf-pt-8'],
  PADDING_TOP_SM: ['wf-pt-12'],
  PADDING_TOP_BASE: ['wf-pt-20'],
  PADDING_TOP_LG: ['wf-pt-32'],
  PADDING_TOP_XL: ['wf-pt-48'],
}

export const PaddingBottomClasses = {
  PADDING_BOTTOM_NONE: ['wf-pb-0'],
  PADDING_BOTTOM_XXXS: ['wf-pb-1'],
  PADDING_BOTTOM_XXS: ['wf-pb-2'],
  PADDING_BOTTOM_XS: ['wf-pb-4'],
  PADDING_BOTTOM_XSS: ['wf-pb-6'],
  PADDING_BOTTOM_SSM: ['wf-pb-8'],
  PADDING_BOTTOM_SM: ['wf-pb-12'],
  PADDING_BOTTOM_BASE: ['wf-pb-20'],
  PADDING_BOTTOM_LG: ['wf-pb-32'],
  PADDING_BOTTOM_XL: ['wf-pb-48'],
}

export const PaddingLeftClasses = {
  PADDING_LEFT_NONE: ['wf-pl-0'],
  PADDING_LFT_XXXS: ['wf-pl-1'],
  PADDING_LEFT_XXS: ['wf-pl-2'],
  PADDING_LEFT_XS: ['wf-pl-4'],
  PADDING_LEFT_XSS: ['wf-pl-6'],
  PADDING_LEFT_SSM: ['wf-pl-8'],
  PADDING_LEFT_SM: ['wf-pl-12'],
  PADDING_LEFT_BASE: ['wf-pl-20'],
  PADDING_LEFT_LG: ['wf-pl-32'],
  PADDING_LEFT_XL: ['wf-pl-48'],
}

export const PaddingRightClasses = {
  PADDING_RIGHT_NONE: ['wf-pr-0'],
  PADDING_RIGHT_XXXS: ['wf-pr-1'],
  PADDING_RIGHT_XXS: ['wf-pr-2'],
  PADDING_RIGHT_XS: ['wf-pr-4'],
  PADDING_RIGHT_XSS: ['wf-pr-6'],
  PADDING_RIGHT_SSM: ['wf-pr-8'],
  PADDING_RIGHT_SM: ['wf-pr-12'],
  PADDING_RIGHT_BASE: ['wf-pr-20'],
  PADDING_RIGHT_LG: ['wf-pr-32'],
  PADDING_RIGHT_XL: ['wf-pr-48'],
}